function create(data){
    return window.axios.post('/api/pago/create', data);
}
export default {
    create
}